module.exports = __webpack_public_path__ + "static/img/remove-err.40013e96.png";